<template>
  <div id="mng-examples">

    <!-- add- / edit-valinta -->
    <div class="flex justify-around pb-4">
      <button
        v-for="mode in modes"
        :key="mode.mode"
        @click="toggleMode(mode.mode)"
        class="btn"
        :class="{ 'btn-empty': mode.mode !== currentMode }"
      >{{ mode.text }}</button>
    </div>

    <!-- kohdelista / olemassa olevat kohteet (EDIT) -->
    <div v-if="currentMode === 'edit'" class="form-field mt-0 mb-4">
      <label for="is-topic">tallennetut kohteet</label>
      <select name="isExample" v-model="isExample" v-on:change="onChange" class="rounded-5">
        <option v-for="(example, index) in examples" :key="index" class="color-black">{{ example.title }}</option>
      </select>
    </div>

    <!-- poista itemi firestoresta -->
    <div v-if="isExample" class="flex justify-center mb-4">
      <div @click="deleteConfirm = true" class="i-flex align-center txt-center font-8 pointer">
        <span class="color-grey">Poista kohde tietokannasta</span>
        <i class="material-icons ml-1 color-grey-l1">delete</i>
      </div>
    </div>
    <!-- poista itemi firestoresta -modal -->
    <div v-if="deleteConfirm" class="fixed tl-0 br-0 flex flex-center" style="background-color: rgba(0, 0, 0, 0.3);">
      <div class="card i-block px-10 py-14 txt-center">
        <p class="font-10 txt-bold">Oletko täysin varma että haluat jatkaa?</p>
        <button @click.prevent="deleteConfirm = false" class="btn block mx-auto mt-4">Peruuta</button>
        <p class="mt-4 font-10">Tehdyt muutokset eivät ole peruttavissa</p>
        <button @click.prevent="confirmDeleteFromDb" class="btn btn-3 block mx-auto mt-8" style="background-color: red;">Poista</button>
        <p>{{ this.deleteConfirmFeedback }}</p>
      </div>
    </div>

    <!-- lomakkeen otsikko -->
    <hr class="border-0 border-t-l1 mb-1">
    <div class="flex justify-between">
      <h2 v-if="currentMode === 'add'" class="mb-5 txt-bold">Kohteen lisäys</h2>
      <h2 v-else class="mb-5 txt-bold">Kohteen muokkaus</h2>
      <i @click="showModal = true" class="material-icons color-grey-l1 font-10 pt-1">help</i>
    </div>

    <!-- tekstin editoinitohjeet - modal -->
    <portal to="modals" v-if="showModal">
      <modal-html-guide
        :show="showModal"
        @close="showModal = false"
      ></modal-html-guide>
    </portal>

    <form @submit.prevent>

      <!-- kohteen nimi -->
      <div class="form-field" :class="{ required: isRequired }">
        <label for="title">kohteen nimi</label>
        <input type="text" name="title" v-model="currentExample.title">
      </div>

      <!-- johdanto (teksti) -->
      <div class="form-field">
        <label for="topic-intro">Johdanto</label>
        <textarea name="topic-intro" rows="3" v-model="currentExample.teaser"></textarea>
      </div>

      <!-- kohteen selite (pääteksti) -->
      <div class="form-field" :class="{ required: isRequired }">
        <label for="main-info">kohteen selite</label>
        <textarea name="main-info" rows="5" v-model="currentExample.mainInfo"></textarea>
      </div>

      <div class="form-field flex justify-center nowrap" :class="{ required: isRequired }">
        <!-- maa -->
        <div class="mr-2">
          <label for="loc-country">maa</label>
          <input type="text" name="loc-country" v-model="currentExample.locCountry">
        </div>
        <!-- kaupunki -->
        <div class="mr-2">
          <label for="loc-city">kaupunki</label>
          <input type="text" name="loc-city" v-model="currentExample.locCity">
        </div>
        <!-- vuosi -->
        <div>
          <label for="year">vuosi</label>
          <input type="number" name="year" v-model="currentExample.year">
        </div>
      </div>

      <!-- osoite -->
      <div class="form-field">
        <label for="example-address">osoite</label>
        <input type="text" name="example-address" v-model="currentExample.address">
      </div>
      <!-- suunnittelu -->
      <div class="form-field">
        <label for="example-by">suunnittelu</label>
        <input type="text" name="example-by" v-model="currentExample.by">
      </div>
      <!-- laajuustiedot -->
      <div class="form-field">
        <label for="example-size">laajuustiedot</label>
        <input type="text" name="example-size" v-model="currentExample.size">
      </div>
      <!-- hallintamuoto -->
      <div class="form-field">
        <label for="example-tenure">hallintamuoto</label>
        <input type="text" name="example-tenure" v-model="currentExample.tenure">
      </div>

      <div class="form-field flex justify-start">
        <!-- lat -->
        <div class="mr-2">
          <label for="map-lat">latitude</label>
          <input type="number" step="any" name="map-lat" v-model="currentExample.mapLat">
        </div>
        <!-- lng -->
        <div class="mr-2">
          <label for="map-lat">longitude</label>
          <input type="number" step="any" name="map-lng" v-model="currentExample.mapLng">
        </div>
        <!-- for styling purposes only -->
        <div>
          <input type="number" style="visibility: hidden;">
        </div>
      </div>

      <!-- taustakuvan ja aksonometrian lisäys -->
      <div class="form-field px-6 py-4 mt-6 border-l2 rounded-5 bg-grey-l5">
        <!-- taustakuva -->
        <div>
          <input
            type="file"
            @change="onFileChange($event, 'hero')"
            style="display: none;"
            ref="inputFileSelectMainImg">
          <button v-if="currentExample.mainImg" @click="$refs.inputFileSelectMainImg.click()" class="btn-empty btn-2- mr-2">muuta taustakuva</button>
          <button v-else @click="$refs.inputFileSelectMainImg.click()" class="btn-empty btn-2- mr-2">lisää taustakuva</button>
          <p v-if="currentExample.mainImg" class="mt-1 txt-bold">{{currentExample.mainImgFilename}}</p>
          <p v-else class="font-8 color-grey-d1 mt-1">-ei valittu-</p>
        </div>
        <!-- taustakuvan tekijätiedot -->
        <div class="form-field mt-2 mb-8">
          <label for="mainimg-author">taustakuvan tekijätiedot</label>
          <input type="text" name="mainimg-author" v-model="currentExample.mainImgAuthor">
        </div>

        <!-- aksonometria -->
        <div>
          <input
            type="file"
            @change="onFileChange($event, 'axo')"
            style="display: none;"
            ref="inputFileSelectMainAxo">
          <button v-if="currentExample.mainAxo" @click="$refs.inputFileSelectMainAxo.click()" class="btn-empty btn-2- mr-2">muuta aksononmetria</button>
          <button v-else @click="$refs.inputFileSelectMainAxo.click()" class="btn-empty btn-2- mr-2">lisää aksononmetria</button>
          <p v-if="currentExample.mainAxo" class="mt-1 txt-bold">{{currentExample.mainAxoFilename}}</p>
          <p v-else class="font-8 color-grey-d1 mt-1">-ei valittu-</p>
        </div>
      </div>

      <!-- keinon lisäys -->
      <div class="form-field px-6 py-4 mt-6 border-l2 rounded-5 bg-grey-l5">
        <!-- tiedot -->
        <label for="is-mean">käytetty keino</label> <!-- LISÄÄ TÄHÄN DYNAAMINEN CLASS! (.required) -->
        <select name="is-mean" v-model="attrTitle" class="rounded-5">
          <option v-for="(mean, index) in meanList" :key="index" class="color-black">{{ mean.title }}</option>
        </select>
        <label for="mean-text" class="mt-2">selite</label> <!-- LISÄÄ TÄHÄN DYNAAMINEN CLASS! (.required) -->
        <textarea name="mean-text" rows="3" v-model="attrText"></textarea>
        <!-- kuvan lisäys -->
        <div class="relative flex align-center mt-1">
          <input
            type="file"
            @change="onFileChange($event, 'mean')"
            style="display: none;"
            ref="inputFileSelect">
          <button @click="$refs.inputFileSelect.click()" class="btn-empty btn-2- mr-2">lisää kuva</button>
          <!-- <span v-if="meanImg" class="font-8">{{ this.meanImg.name }}</span>
          <i v-if="meanImg" class="material-icons absolute r-0 color-grey" @click="meanImg = null">delete</i> -->
        </div>

        <!-- lisätyt kuvat (+ kuvatekstit) -->
        <div v-for="(group, index) in attrSubGroups" :key="index" class="mt-1 txt-bold flex justify-between align-center">
          <div class="flex-1">
            <p>{{ group.filename }}</p>
            <input v-model="group.imageText" type="text" placeholder="kuvateksti..." class="mt-1">
          </div>
          <i @click="$delete(attrSubGroups, index)" class="material-icons ml-2 color-grey">delete</i>
        </div>

        <!-- kuvatekstin lisäys -->
        <!-- <label v-if="meanImg" for="mean-image-text" class="mt-2">kuvateksti</label>
        <input v-if="meanImg" type="text" name="mean-image-text" v-model="meanImgText"> -->

        <!-- feedback ja "liitä"-nappi -->
        <p v-if="meanFeedback">{{ this.meanFeedback }}</p>
        <button @click.prevent="addAttr" class="btn mt-4">liitä</button>
        <!-- <button @click.prevent="addMean" class="btn mt-4">liitä</button> -->
      </div>

      <!-- fieldit (lista) -->
      <div class="form-field" v-if="currentExample.addedMeans">
        <div v-for="(attr, index) in currentExample.addedMeans" :key="index" class="flex justify-between align-center mb-4">
          <div class="relative oflow-hidden mr-2 flex-1">
            <h3 class="txt-bold font-11">{{ attr.title }}</h3>
            <p class="w-full ellipsis font-9">{{ attr.text }}</p>
            <div v-for="(pair, index) in attr.imgTextPairs" :key="index" class="mt-1">
              <p class="color-grey">kuva {{index+1}}: <span class="color-theme txt-bold">{{pair.filename}}</span></p>
              <p v-if="pair.imageText" class="color-grey">kuvateksti: <span class="color-black">{{pair.imageText}}</span></p>
            </div>
          </div>
          <i class="material-icons color-grey" @click="editAttr(index)">edit</i>
          <i class="material-icons color-grey" @click="deleteAttr(index)">delete</i>
        </div>
      </div>

      <p v-if="feedback" class="txt-center">{{ this.feedback }}</p>
      <button @click.self="addToDatabase" class="btn btn-3 block mx-auto mt-6">{{this.addOrEdit}}</button>

    </form>

  </div>
</template>

<script>
// ===================================================================================================================
import db from '@/firebase/init'
import firebase from 'firebase'
import slugify from 'slugify'
import modalHtmlGuide from '../components/modals/modalHtmlGuide'
import uuidv4 from 'uuid/v4'

export default {
  name: 'mngExamples',

  components: {
    modalHtmlGuide
  },

  data () {
    return {
      modes: [
        { mode: 'add', text: 'lisää' },
        { mode: 'edit', text: 'muokkaa' }
      ],
      currentMode: 'add',
      examples: [], // created():sta

      imageFolderMeans: 'means',
      imageFolderExamples: 'examples',
      thumbS_suffix: '_thumb@200',
      thumbM_suffix: '_thumb@420',

      exampleDB: 'kohteet',
      meanDB: 'keinot',

      isExample: null, // <select>:stä

      currentExample: this.createExampleObject(),

      deleteList: [],

      meanList: [], // kannasta haetut keinot // POISTUU!!!
      selected: [], // valitut keinot // POISTUU!!!

      feedback: null,
      isRequired: false,
      showMeanList: false,
      // keinon lisäyskenttä:
      meanTitle: null, // <select>:issä valittu keino
      meanText: null,
      meanImg: null,
      meanImgText: null,
      meanFeedback: null,

      deleteConfirm: false, // varmistus: itemin deletointi kannasta
      deleteConfirmFeedback: null,

      deleteFeedback: 'Kohde poistettu tietokannasta',

      showModal: false, // tekstin editointiohjeet

      // uusimmat:
      attrTitle: null, // otsikko
      attrText: null, // selite
      attrSubGroups: [], // kuva + kuvateksti -pari
      teaser: null, // galleriakortin teksti
      mainImg: null, // kohteen taustakuva
      mainAxo: null // kohteen aksonometria

    }
  },

  created () {
    this.getExamples() // POISTUU!!!
    this.getMeans() // POISTUU!!!
  },

  computed: {
    addOrEdit () { // <form>:n buttonin teksti
      if (this.isExample) {
        return 'muokkaa'
      } else {
        return 'lisää'
      }
    }
  },

  methods: {
    getExamples () { // hakee kaikki kohteet, created() // POISTUU!!!
      this.examples = []
      db.collection(this.exampleDB).get().then(snapshot => {
        snapshot.docs.forEach(doc => {
          let kohde = doc.data()
          kohde.id = doc.id // tarvitaanko?
          this.examples.push(kohde)
        })
      })
    },

    getMeans () { // hakee kaikki keinot, created() // POISTUU!!!
      this.meanList = []
      db.collection(this.meanDB).get().then(snapshot => {
        snapshot.docs.forEach(doc => {
          let mean = doc.data()
          this.meanList.push(mean)
        })
      })
    },

    toggleMode (mode) {
      this.clearFields()
      this.getExamples()
      this.getMeans()
      this.currentMode = mode
    },

    onChange () { // kun <option> valitaan <select>:ssä
      if (this.isExample) {
        let current = this.examples.find(example => {
          return example.title === this.isExample
        })

        this.currentExample = this.createExampleObject(current)
      }
    },

    onFileChange (event, what) { // kun input(type=file) ottaa uuden filen vastaan
      if (what === 'mean') {
        this.attrSubGroups.push({
          image: event.target.files[0],
          imageText: null,
          filename: event.target.files[0].name
        })
      } else if (what === 'axo') {
        if (this.currentExample.mainAxo) {
          this.deleteList.push({ file: this.currentExample.mainAxo, folder: this.imageFolderExamples })
        }
        this.currentExample.mainAxo = event.target.files[0]
        this.currentExample.mainAxoFilename = event.target.files[0].name
      } else if (what === 'hero') {
        if (this.currentExample.mainImg) {
          this.deleteList.push({ file: this.currentExample.mainImg, folder: this.imageFolderExamples })
          if (this.currentExample.mainImg_thumbM && typeof this.currentExample.thumbM === 'string') {
            this.deleteList.push({ file: this.currentExample.mainImg_thumbM, folder: this.imageFolderExamples })
          }
          if (this.currentExample.mainImg_thumbS && typeof this.currentExample.thumbS === 'string') {
            this.deleteList.push({ file: this.currentExample.mainImg_thumbS, folder: this.imageFolderExamples })
          }
        }

        this.currentExample.mainImg = event.target.files[0]
        this.currentExample.mainImgFilename = event.target.files[0].name
      }
    },

    addAttr () { // lisää fields:[] :iin
      if (this.attrTitle && this.attrText) {
        this.attrFeedback = null

        // let current = this.$store.state.means.find(mean => {
        let current = this.meanList.find(mean => {
          return mean.title === this.attrTitle
        })

        this.currentExample.addedMeans.push({
          title: this.attrTitle,
          text: this.attrText,
          imgTextPairs: this.attrSubGroups,
          ref: current.ref,
          slug: current.slug,
          categoryTitle: current.categoryTitle,
          categoryIcon: current.categoryIcon
        })

        this.attrSubGroups.forEach(attrSG => {
          this.deleteList.splice(this.deleteList.findIndex(el => {
            return el.file === attrSG.image
          }), 1)
          this.deleteList.splice(this.deleteList.findIndex(el => {
            return el.file === attrSG.thumbM
          }), 1)
          this.deleteList.splice(this.deleteList.findIndex(el => {
            return el.file === attrSG.thumbS
          }), 1)
        })

        this.attrTitle = null
        this.attrText = null
        this.attrSubGroups = []
      } else {
        this.attrFeedback = 'täytä tarvittavat kentät'
      }
      this.$refs.inputFileSelect.value = ''
    },

    deleteAttr (index) {
      let self = this

      const promises = this.currentExample.addedMeans[index].imgTextPairs.map(
        img => new Promise(resolve => {
          if (img.image && typeof img.image === 'string') {
            self.deleteList.push({ file: img.image, folder: self.imageFolderMeans })
          }
          if (img.thumbM && typeof img.thumbM === 'string') {
            self.deleteList.push({ file: img.thumbM, folder: self.imageFolderMeans })
          }
          if (img.thumbS && typeof img.thumbS === 'string') {
            self.deleteList.push({ file: img.thumbS, folder: self.imageFolderMeans })
          }
          resolve()
        })
      )

      Promise.all(promises).then(() => {
        self.$delete(self.currentExample.addedMeans, index)
      })
    },

    editAttr (index) {
      this.attrTitle = this.currentExample.addedMeans[index].title
      this.attrText = this.currentExample.addedMeans[index].text
      this.attrSubGroups = this.currentExample.addedMeans[index].imgTextPairs

      this.deleteAttr(index)
    },

    confirmDeleteFromDb () {
      let toBeDeleted = this.examples.find(exa => {
        return exa.title === this.isExample
      }).id

      let self = this

      this.currentExample.addedMeans.forEach(mean => {
        mean.imgTextPairs.forEach(img => {
          self.deleteList.push({ file: img.image, folder: self.imageFolderMeans })
          if (img.thumbM && typeof img.thumbM === 'string') {
            self.deleteList.push({ file: img.thumbM, folder: self.imageFolderMeans })
          }
          if (img.thumbS && typeof img.thumbS === 'string') {
            self.deleteList.push({ file: img.thumbS, folder: self.imageFolderMeans })
          }
        })
      })

      db.collection(this.exampleDB).doc(toBeDeleted).delete()
        .then(() => {
          this.deleteConfirmFeedback = this.deleteFeedback

          this.clearFields()
          this.getExamples()
          this.getMeans()

          let deletePromises = []
          if (self.deleteList.length > 0) {
            deletePromises = self.deleteList.map(filu => new Promise((resolve, reject) => {
              self.deleteImage(filu.file, filu.folder, resolve)
            }))
          }
          Promise.all(deletePromises).then(() => {
            self.deleteList = []
          })

          setTimeout(() => {
            this.deleteConfirm = false
            this.deleteConfirmFeedback = null
            this.isExample = null
            this.$store.dispatch('changeUpdateState', 'examples')
          }, this.deleteTimeout)
        })
    },

    uploadImage (file, ind, jnd, title, resolve) {
      let ref
      let name1 = file.name.split('.')[0]
      let imgType
      if (ind === null) {
        imgType = 'bg'
        ref = firebase.storage().ref(this.imageFolderExamples)
        name1 = name1 + '_' + uuidv4()
      } else if (jnd === null) {
        imgType = 'axo'
        ref = firebase.storage().ref(this.imageFolderExamples)
        name1 = name1 + '_' + uuidv4()
      } else {
        imgType = 'mean'
        ref = firebase.storage().ref(this.imageFolderMeans)
        name1 = name1 + '_' + uuidv4()
      }

      const name2 = file.name.split('.').pop()
      const name = name1 + '.' + name2
      const metadata = { contentType: file.type }
      const task = ref.child(name).put(file, metadata)

      let self = this

      task
        .then(snapshot => snapshot.ref.getDownloadURL())
        .then(url => {
          var filename = url.split(name)
          if (imgType === 'mean') {
            self.currentExample.addedMeans[ind].imgTextPairs[jnd].image = url
            if (name2 !== 'svg') {
              self.currentExample.addedMeans[ind].imgTextPairs[jnd].thumbS = filename[0] + name1 + self.thumbS_suffix + '.png' + filename[1]
              self.currentExample.addedMeans[ind].imgTextPairs[jnd].thumbM = filename[0] + name1 + self.thumbM_suffix + '.png' + filename[1]
            } else {
              self.currentExample.addedMeans[ind].imgTextPairs[jnd].thumbS = null
              self.currentExample.addedMeans[ind].imgTextPairs[jnd].thumbM = null
            }
          } else if (imgType === 'bg') {
            self.currentExample.mainImg = url
            if (name2 !== 'svg') {
              self.currentExample.mainImg_thumbS = filename[0] + name1 + self.thumbS_suffix + '.png' + filename[1]
              self.currentExample.mainImg_thumbM = filename[0] + name1 + self.thumbM_suffix + '.png' + filename[1]
            } else {
              self.currentExample.mainImg_thumbS = null
              self.currentExample.mainImg_thumbM = null
            }
          } else if (imgType === 'axo') {
            self.currentExample.mainAxo = url
          }
          resolve()
        })
    },

    deleteImage (file, folder, resolve) {
      // console.log(file)
      const name = file.split('%2F')[1].split('?')[0]
      const ref = firebase.storage().ref(folder)
      const task = ref.child(name).delete()

      task
        .then(() => {
          resolve()
        })
        .catch(err => {
          console.error('ERROR: ', err)
          resolve()
        })
    },

    uploadAttr (attr, ind, title, resolve) {
      var self = this

      const promises = attr.map((img, jnd) => new Promise((resolve, reject) => {
        if (typeof img.image === 'string') {
          // image already in storage
          resolve()
        } else {
          // adding new image to storage
          self.uploadImage(img.image, ind, jnd, title, resolve)
        }
      }))

      Promise.all(promises).then(() => {
        resolve()
      })
    },

    addToDatabase () { // lisää / päivitä kohde tietokantaan
      if (this.currentExample.title && this.currentExample.locCountry &&
      this.currentExample.locCity && this.currentExample.year && this.currentExample.mainInfo) {
        this.feedback = null
        this.isRequired = false
        this.currentExample.slug = slugify(this.currentExample.title, {
          replacement: '-',
          remove: /[$*_+~.()'"!\-:@]/g,
          lower: true
        })

        let self = this
        let deletePromises = []
        if (self.deleteList.length > 0) {
          deletePromises = self.deleteList.map(filu => new Promise((resolve, reject) => {
            self.deleteImage(filu.file, filu.folder, resolve)
          }))
        }
        Promise.all(deletePromises).then(() => {
          self.deleteList = []
          const promises = this.currentExample.addedMeans.map((filu, ind) => new Promise((resolve, reject) => {
            self.uploadAttr(filu.imgTextPairs, ind, self.currentExample.slug, resolve)
          }))

          if (this.currentExample.mainImg && typeof this.currentExample.mainImg !== 'string') {
            promises.push(new Promise(resolve => this.uploadImage(this.currentExample.mainImg, null, 1, this.currentExample.slug, resolve)))
          }
          if (this.currentExample.mainAxo && typeof this.currentExample.mainAxo !== 'string') {
            promises.push(new Promise(resolve => this.uploadImage(this.currentExample.mainAxo, 1, null, this.currentExample.slug, resolve)))
          }

          Promise.all(promises).then(() => {
            if (self.isExample) {
              // muokkaa vanhaa
              db.collection(self.exampleDB).doc(self.currentExample.id).update(self.currentExample)
                .then(() => {
                  self.clearFields()
                  self.feedback = self.updateFeedback
                  self.isRequired = false

                  self.getExamples()
                  self.getMeans() // update means array

                  setTimeout(() => {
                    self.feedback = null
                    this.$store.dispatch('changeUpdateState', 'examples')
                  }, self.updateTimeout)
                })
            } else {
              // lisää uusi
              db.collection(self.exampleDB).add(self.currentExample)
                .then(() => {
                  self.clearFields()
                  self.feedback = self.addFeedback
                  self.isRequired = false

                  self.getExamples()
                  self.getMeans() // update means array

                  setTimeout(() => {
                    self.feedback = null
                    this.$store.dispatch('changeUpdateState', 'examples')
                  }, self.addTimeout)
                })
            }
          })
        })
      } else {
        this.feedback = this.requiredFeedback
        this.isRequired = true
      }
    },

    createExampleObject (dbObj) {
      let newExample = {
        id: null,
        addedMeans: [],
        by: null,
        locCity: null,
        locCountry: null,
        mainAxo: null,
        mainAxoFilename: null,
        mainImg: null,
        mainImgFilename: null,
        mainImg_thumbM: null,
        mainImg_thumbS: null,
        mainImgAuthor: null, //* *!!**
        mainInfo: null,
        address: null,
        mapLat: null,
        mapLng: null,
        size: null,
        slug: null,
        teaser: null,
        tenure: null,
        title: null,
        year: null
      }
      if (dbObj) {
        newExample.id = dbObj.id
        newExample.addedMeans = dbObj.addedMeans || []
        newExample.by = dbObj.by
        newExample.locCity = dbObj.locCity
        newExample.locCountry = dbObj.locCountry
        newExample.mainAxo = dbObj.mainAxo
        newExample.mainAxoFilename = dbObj.mainAxoFilename || null
        newExample.mainImg = dbObj.mainImg
        newExample.mainImgFilename = dbObj.mainImgFilename || null
        newExample.mainImg_thumbM = dbObj.mainImg_thumbM || null
        newExample.mainImg_thumbS = dbObj.mainImg_thumbS || null
        newExample.mainImgAuthor = dbObj.mainImgAuthor || null //* *!!**
        newExample.mainInfo = dbObj.mainInfo
        newExample.address = dbObj.address
        newExample.mapLat = dbObj.mapLat
        newExample.mapLng = dbObj.mapLng
        newExample.size = dbObj.size
        newExample.slug = dbObj.slug
        newExample.teaser = dbObj.teaser
        newExample.tenure = dbObj.tenure
        newExample.title = dbObj.title
        newExample.year = dbObj.year
      }
      return newExample
    },

    clearFields () {
      this.currentExample = this.createExampleObject()

      this.attrTitle = null
      this.attrText = null

      this.attrSubGroups = []

      // clear form fields
      this.isExample = null // tallennetut kohteet -valikon valinta
      // this.isCategory = null // kategoria-valikon valinta
    }
  }
}
</script>

<style lang="scss">
// ===================================================================================================================
#mng-examples li { font-size: 0.7rem; }
#mng-examples li i { font-size: 0.7rem; }

/* .form-item-delete:hover { color: red !important; } */

</style>
